import { render, staticRenderFns } from "./CrAparatDestination.vue?vue&type=template&id=485cacd6&"
import script from "./CrAparatDestination.vue?vue&type=script&lang=js&"
export * from "./CrAparatDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports